import { Link } from "react-router-dom";
import { Mail, Phone, Linkedin, Twitter, Facebook, Instagram, ArrowUpRight } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="relative bg-[#050812] border-t border-white/5 overflow-hidden" data-testid="site-footer">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[500px] rounded-full blur-[160px] opacity-25 pointer-events-none"
        style={{ background: "radial-gradient(ellipse, #10B981 0%, transparent 70%)" }} />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 sm:pt-28 pb-10">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-6 space-y-8">
            <p className="font-inter text-xs tracking-[0.24em] uppercase text-[#10B981] font-semibold">Let's build your career</p>
            <h2 className="font-poppins text-4xl sm:text-5xl md:text-6xl text-white font-semibold tracking-tight leading-[1.05]">
              Your <span className="text-gradient">US tech career</span> starts with one conversation.
            </h2>
            <p className="font-inter text-white/60 max-w-xl">
              Talk to a senior US career advisor today. Free 30-minute consultation, resume audit and a personalized visa + role roadmap.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/contact"
                data-testid="footer-cta-hire"
                className="inline-flex items-center gap-2 font-inter text-sm font-medium text-white px-6 py-3 rounded-full"
                style={{ background: "linear-gradient(120deg, #1E3A8A, #10B981)" }}
              >
                Book Free Consultation <ArrowUpRight className="w-4 h-4" />
              </Link>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-cta-email"
                className="inline-flex items-center gap-2 font-inter text-sm text-white/80 px-6 py-3 rounded-full border border-white/10 hover:bg-white/5"
              >
                <Mail className="w-4 h-4" /> {CONTACT.email}
              </a>
            </div>
          </div>

          <div className="lg:col-span-6 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <p className="font-poppins font-semibold text-white text-sm mb-4">Company</p>
              <ul className="space-y-3">
                {NAV_LINKS.slice(0, 4).map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="font-inter text-sm text-white/60 hover:text-white transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-poppins font-semibold text-white text-sm mb-4">Explore</p>
              <ul className="space-y-3">
                {NAV_LINKS.slice(4).map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="font-inter text-sm text-white/60 hover:text-white transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-poppins font-semibold text-white text-sm mb-4">Contact</p>
              <ul className="space-y-3">
                <li>
                  <a href={`mailto:${CONTACT.email}`} className="font-inter text-sm text-white/60 hover:text-white flex items-center gap-2">
                    <Mail className="w-3.5 h-3.5" /> Email
                  </a>
                </li>
                <li>
                  <a href={`tel:${CONTACT.phoneClean}`} className="font-inter text-sm text-white/60 hover:text-white flex items-center gap-2">
                    <Phone className="w-3.5 h-3.5" /> {CONTACT.phone}
                  </a>
                </li>
              </ul>
              <div className="flex gap-3 mt-5">
                {[Linkedin, Twitter, Facebook, Instagram].map((Icon, i) => (
                  <a
                    key={i}
                    href="#"
                    aria-label="social"
                    className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-white hover:border-white/30 transition-colors"
                  >
                    <Icon className="w-4 h-4" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center sm:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src="/logo-icon-sm.png"
              alt="SKVY Harmony Placement"
              className="h-14 sm:h-16 w-auto object-contain drop-shadow-[0_8px_24px_rgba(59,130,246,0.4)]"
            />
            <div className="flex flex-col leading-none">
              <span className="font-poppins font-semibold text-white text-base tracking-tight">SKVY Harmony</span>
              <span className="font-inter text-[10px] text-white/50 tracking-[0.18em] uppercase">Placement</span>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 font-inter text-xs text-white/40 sm:justify-end">
            <Link to="/contact" className="hover:text-white">Privacy Policy</Link>
            <Link to="/contact" className="hover:text-white">Terms &amp; Conditions</Link>
            <span>© {new Date().getFullYear()} SKVY Harmony Placement. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
